import { Link } from "@tanstack/react-router";
import { useEffect } from "react";
import { useVideoPlayer } from "@/components/home/video-player";

/** Home only, below lg: fixed booking + WhatsApp pill. Adds page bottom padding so it never covers the footer. */
export function MobileBookingBar({ whatsappUrl }: { whatsappUrl: string | null }) {
  const { open } = useVideoPlayer();
  useEffect(() => {
    document.body.classList.add("home-bar-pad");
    return () => document.body.classList.remove("home-bar-pad");
  }, []);
  if (open) return null;
  const cell = "inline-flex min-h-[52px] flex-1 items-center justify-center rounded-ds-pill px-4 font-display text-[15px] font-bold";
  return (
    <div
      className="fixed inset-x-3 z-30 flex gap-2 rounded-ds-pill bg-surface/95 p-1.5 shadow-lg backdrop-blur lg:hidden"
      style={{ bottom: "calc(12px + env(safe-area-inset-bottom))" }}
    >
      <Link to="/book" className={cell + " bg-primary text-primary-foreground"}>حجز استشارة</Link>
      {whatsappUrl && (
        <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className={cell + " bg-maroon-100 text-maroon-500"}>
          سؤال على واتساب
        </a>
      )}
    </div>
  );
}
